import {interpolateRgbBasis} from "d3-interpolate";

export default scheme => interpolateRgbBasis(scheme[scheme.length - 1]);



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/ramp.js
// module id = 7
// module chunks = 0